import CustomerOrderItemModelBase from '../_generated/modelBases/customer-order-item-model-base';

export default class CustomerOrderItemModel extends CustomerOrderItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
